export enum ToolType {
  EXTRUSION = 'EXTRUSION',
  SINGLE_MOLD = 'SINGLE_MOLD'
}
